import React from 'react';
import Input from '../../layout/input/Input';
import InputMoeda from '../../layout/input/InputMoeda';
import InputMemo from '../../layout/input/InputMemo';
import InputNumber from '../../layout/input/InputNumber';
import InputData from '../../layout/input/InputData';
import InputDataHora from '../../layout/input/InputDataHora';
import InputSelect from '../../layout/input/InputSelect';

import { formatarData, formatarDataTime, moeda, formataQuantidadeFloat } from "../../../helper/Formatar";

function getOptions(value) {
    const myArray = value.split(',');
    let option = [];

    myArray.forEach(element => {
        let item = {};

        item.valor = element.trim();
        item.texto = element.trim();

        option.push(item);
    });

    return option;
}

var TypeFieldEnum = {
    TEXT: {
        enumName: 'TEXT',        
        format: function(value) {
            return value;
        },
        component: function(props, chave, value) {
            return (
                <Input
                    type='text'
                    id="mycomponent"
                    nome="mycomponent"
                    ref={ref => this.mycomponent = ref}
                    value={value}
                    defaultValue={value}
                    maxLength={255}
                    defaultFoco={true}
                    onChange={(e) => props.props.onChange(e)}
                >
                    {chave}
                </Input>
            );
        }
    },
    MEMO: {
        enumName: 'MEMO',        
        format: function(value) {
            return value;
        },
        component: function(props, chave, value) {
            return (
                <InputMemo
                    type='memo'
                    id="mycomponent"
                    nome="mycomponent"
                    ref={ref => this.mycomponent = ref}
                    value={value}
                    defaultValue={value}                    
                    defaultFoco={true}
                    onChange={(e) => props.props.onChange(e)}
                >
                    {chave}
                </InputMemo>
            );
        }
    },
    MOEDA: {
        enumName: 'MOEDA',        
        format: function(value) {
            return 'R$ ' + moeda(value);
        },
        component: function(props, chave, value) {            
            return (
                <InputMoeda
                    type='text'
                    id="mycomponent"
                    nome="mycomponent"
                    ref={ref => this.mycomponent = ref}
                    symbol="R$"
                    value={value}
                    defaultValue={value}
                    defaultFoco={true}
                    onChangeEvent={(e) => props.props.onChange(e)}
                >
                    {chave}
                </InputMoeda>
            );
        }
    },
    NUMBER: {
        enumName: 'NUMBER',        
        format: function(value, scale, isInteger) {
            if(isInteger === undefined)
                return formataQuantidadeFloat(value, scale);

            if(Number.isInteger(value))
                return value;

            return formataQuantidadeFloat(value, scale);
        },
        component: function(props, chave, value) {
            return (
                <InputNumber                    
                    id="mycomponent"
                    nome="mycomponent"
                    ref={ref => this.mycomponent = ref}
                    value={value}
                    defaultValue={value}
                    defaultFoco={true}
                    onChange={(e) => props.props.onChange(e)}
                >
                    {chave}
                </InputNumber>
            );
        }
    },
    DATE: {
        enumName: 'DATE',        
        format: (value) => { 
            return formatarData(value);
        },
        component: function(props, chave, value) {
            return (
                <InputData                    
                    id="mycomponent"
                    nome="mycomponent"
                    ref={ref => this.mycomponent = ref}
                    value={value}
                    defaultValue={value}
                    defaultFoco={true}
                    onChange={(e) => props.props.onChange(e)}
                >
                    {chave}
                </InputData>
            );
        }
    },
    DATETIME: {
        enumName: 'DATETIME',        
        format: (value) => { 
            return formatarDataTime(value);
        },
        component: function(props, chave, value) {
            return (
                <InputDataHora                    
                    id="mycomponent"
                    nome="mycomponent"
                    ref={ref => this.mycomponent = ref}
                    value={value}
                    defaultValue={value}
                    defaultFoco={true}
                    onChange={(e) => props.props.onChange(e)}
                >
                    {chave}
                </InputDataHora>
            );
        }
    },
    ENUM: {
        enumName: 'ENUM',        
        format: function(value) {            
            return value;
        },
        component: function(props, chave, value, enumValue) {
            if(enumValue === undefined)
                return ;            

            let options = getOptions(enumValue);                        

            return (
                <InputSelect                    
                    id="mycomponent"
                    nome="mycomponent"
                    ref={ref => this.mycomponent = ref}
                    value={value}
                    options={options}
                    defaultValue={value}
                    defaultFoco={true}
                    onChange={(e) => props.props.onChange(e)}
                >
                    {chave}
                </InputSelect>
            );
        }
    },
    get(value) {              
        if(value === null)
            return TypeFieldEnum.TEXT;

        value = value.toUpperCase();

        var array = Object.values(TypeFieldEnum);
        var typeFieldEnumFound = {};

        array.forEach(element => {            
            if(element.enumName === value) {
                typeFieldEnumFound = element;      
                return ;          
            }            
        });   
        
        return typeFieldEnumFound;
    }
}

export default TypeFieldEnum;